import { render, staticRenderFns } from "./MinusCircleIcon.vue?vue&type=template&id=6fedc200"
import script from "./MinusCircleIcon.vue?vue&type=script&lang=ts"
export * from "./MinusCircleIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports